import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Button } from '@app/core';
import { Trans, useTranslation } from 'react-i18next';
import {
  FLASH_OFFER_CALENDAR_LINK,
  FLASH_OFFER_URL,
  useIsSpecialOfferBannerActive,
} from './isSpecialOfferActive';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase,

    backgroundColor: theme.colors.accentMuted,
    borderRadius: theme.borderRadius.large,
    padding: theme.marginBase * 3,
    margin: [[theme.marginBase * 2, 'auto']],
  },
  text: {
    ...theme.fonts.h4,
    '& strong': {
      color: theme.colors.accentAccessible,
    },
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase,
  },
}));

export const SpecialOfferBigBlock = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isSpecialOfferActive = useIsSpecialOfferBannerActive();
  if (!isSpecialOfferActive) {
    return null;
  }

  return (
    <div className={classes.container}>
      <p className={classes.text}>
        <Trans i18nKey="billing.specialOffer.bigBlock.home" />
      </p>
      <Button
        color="accent"
        to={FLASH_OFFER_URL}
        small
        target={FLASH_OFFER_URL.startsWith('http') ? '_blank' : undefined}
      >
        {t('billing.specialOffer.bigBlock.view')}
      </Button>
      <Button
        color="accent"
        variant="muted"
        href={FLASH_OFFER_CALENDAR_LINK}
        target="_blank"
        small
      >
        {t('billing.specialOffer.bigBlock.call')}
      </Button>
    </div>
  );
};
